function sessionId(): string {
  try {
    let id = sessionStorage.getItem('fs:bootSession');
    if (!id) { id = crypto.randomUUID(); sessionStorage.setItem('fs:bootSession', id); }
    return id;
  } catch { return crypto.randomUUID(); }
}
export function sendBootBeacon(apiBase: string, phase: 'started' | 'ready' | 'failed', app: string, version = ''): void {
  const body = JSON.stringify({ sessionId: sessionId(), app, phase, appVersion: version, isIframe: window.self !== window.top });
  const url = `${apiBase}/public/telemetry/boot`;
  if (!navigator.sendBeacon?.(url, new Blob([body], { type: 'application/json' }))) {
    void fetch(url, { method: 'POST', headers: { 'content-type': 'application/json' }, body, keepalive: true }).catch(() => undefined);
  }
}
